import { Organization } from '../../../../core/models/entities/Organization'
import { useCustomerCreateFormViewModel } from '../vmHooks/useCustomerCreateFormViewModel'
import { CustomerCreateWizard } from '../components/customer-create-wizard.component'

interface WrapperProps {
  vendors?: Organization[]
}

export function CustomerCreateFormWrapper({ vendors }: WrapperProps) {
  const vm = useCustomerCreateFormViewModel(vendors)
  return <CustomerCreateWizard {...vm} />
}
